import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/features/auth'

export const AuthRedirect = () => {
  const { user, initialized: authInitialized } = useAuth()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (!user) return

    const urlParams = new URLSearchParams(location.search)
    // RequireAuth emits `redirect_to`, the header/login buttons emit `login_redirect`
    const redirectUrl = urlParams.get('login_redirect') ?? urlParams.get('redirect_to')

    if (redirectUrl) {
      if (location.pathname !== '/auth/register') {
        if (redirectUrl.startsWith('http')) {
          window.location.href = redirectUrl
        } else {
          navigate(redirectUrl, { replace: true })
        }
      }
      return
    }

    // Don't auto redirect logged in users for password reset pages
    if (['/auth/forgot-password', '/auth/reset-password'].includes(location.pathname)) return

    if (location.pathname.startsWith('/auth/')) {
      navigate('/dashboard', { replace: true })
    }
  }, [authInitialized, user, location.search, location.pathname, navigate])

  return <></>
}
